import request from '@/utils/request'

export function createOrder(data) {
  return request({
    url: '/orders',
    method: 'post',
    data
  })
}

export function getOrders(params) {
  const p =
    typeof params === 'string'
      ? Object.fromEntries(new URLSearchParams(params))
      : { ...(params || {}) }

  return request({
    url: '/orders',
    method: 'get',
    params: p
  })
}

export function getOrdersSummary(params) {
  const p = typeof params === 'string'
    ? Object.fromEntries(new URLSearchParams(params))
    : { ...(params || {}) }

  return request({
    url: '/orders/summary',
    method: 'get',
    params: p
  })
}

export function getOrderById(id) {
  return request({
    url: `/orders/${id}`,
    method: 'get'
  })
}

export function voidOrder(orderId, reason) {
  return request({
    url: `/orders/${orderId}/void`,
    method: 'post',
    data: { reason }
  })
}

export function updateOrderPaymentMethod(orderId, paymentMethod) {
  return request({
    url: `/orders/${orderId}/payment-method`,
    method: 'put',
    data: { paymentMethod }
  })
}
